export default "__VITE_ASSET__BRzXsqrC__"